/**
 * ZBERNA FAKTURA: odoslanie mailom alebo stiahnutie PDF (24.10.2026).
 *
 * `target` je nepovinny. Bez neho ide doklad zakaznikovi na fakturacny mail
 * z karty majitela a kopia (CC) uctovnickej. Doteraz to boli dve kliknutia
 * a dve volania, takze sa dalo poslat len jednej strane a na druhu zabudnut.
 *
 * `type: "download"` vrati PDF, inak sa posiela mail.
 */
const zbernaFakturaAkcia = async (id, type, target) => {
  var axios = require("axios");

  const url =
    process.env.REACT_APP_BACKEND_API_URL +
    "/email/send-collective-invoice?apikey=" +
    process.env.REACT_APP_TOKEN_API;

  const config = {
    method: "post",
    // Pri stiahnuti potrebujeme binarku, pri maili staci JSON. Blob by
    // z chybovej odpovede urobil necitatelny objekt, preto to rozlisujeme.
    responseType: type === "download" ? "blob" : "json",
    url: url,
    headers: { "Content-Type": "application/json" },
    data: { id, type, target },
  };

  return await axios(config)
    .then(function(response) {
      return { status: true, data: response.data };
    })
    .catch(function(error) {
      console.log(error);
      return { status: false, error: error };
    });
};

/** Stiahne PDF zbernej faktury do suboru. */
export const stiahniZbernuFakturu = async (id, cislo) => {
  const vysledok = await zbernaFakturaAkcia(id, "download");
  if (!vysledok.status) return vysledok;
  const odkaz = window.URL.createObjectURL(new Blob([vysledok.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = odkaz;
  a.download = `Faktura-${cislo || id}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(odkaz);
  return vysledok;
};

/** Posle fakturu mailom. Bez `target` zakaznikovi a v kopii uctovnickej. */
export const posliZbernuFakturu = async (id, target) => {
  return await zbernaFakturaAkcia(id, "email", target);
};

export default zbernaFakturaAkcia;
